import { Button } from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';

import { CODE_TYPES, type CodeType } from '../../interface/codes';
import { useCodingScreen } from '../../interface/context';
import type { SlotProps } from '../../interface/slotProps';
import { AddCodeModal } from '../AddCodeModal';

const asCodeType = (value: unknown): CodeType | undefined =>
  CODE_TYPES.find((codeType) => codeType === value);

export const AddCodeAction: React.FC<SlotProps> = ({ item, value }) => {
  const { bus } = useCodingScreen();
  const [isOpen, setIsOpen] = useState(false);
  const [requestedType, setRequestedType] = useState<CodeType | undefined>(undefined);
  const [openedByEvent, setOpenedByEvent] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);

  useEffect(
    () =>
      bus?.on('addCode.open', (detail) => {
        setRequestedType(asCodeType((detail as { codeType?: unknown } | undefined)?.codeType));
        setOpenedByEvent(true);
        setIsOpen(true);
      }),
    [bus]
  );

  const close = (): void => {
    setIsOpen(false);
    setRequestedType(undefined);
  };

  return (
    <>
      <Button
        ref={triggerRef}
        size="sm"
        variant="outline"
        data-slot-key={item.contentKey}
        _focusVisible={{ boxShadow: 'inset 0 0 0 2px rgba(66, 153, 225, 0.6)' }}
        onClick={() => {
          setOpenedByEvent(false);
          setIsOpen(true);
        }}
      >
        Add code
      </Button>
      <AddCodeModal
        isOpen={isOpen}
        onClose={close}
        finalFocusRef={openedByEvent ? undefined : triggerRef}
        initialCodeType={requestedType ?? asCodeType(value)}
      />
    </>
  );
};
